const VISITOR_SUBMITTER_KEY_STORAGE = "karin_visitor_submitter_key_v1";

function bytesToHex(bytes: Uint8Array): string {
  return [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function getVisitorSubmitterKey(): string {
  let key = localStorage.getItem(VISITOR_SUBMITTER_KEY_STORAGE);
  if (!key) {
    key = crypto.randomUUID();
    localStorage.setItem(VISITOR_SUBMITTER_KEY_STORAGE, key);
  }
  return key;
}

export async function hashVisitorSubmitterKey(key: string): Promise<string> {
  const data = new TextEncoder().encode(key);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return bytesToHex(new Uint8Array(digest));
}

export async function getVisitorSubmitterHash(): Promise<string> {
  return hashVisitorSubmitterKey(getVisitorSubmitterKey());
}
